export const blockIconsSocialDiamondNew = (
	<span className='material-symbols-outlined'>diamond</span>
);
